module.exports = __webpack_public_path__ + "media/customizations/regencyatstonebrook/logo-c0b5dfdffe2e37aed246b8b62f2094c6.png";